import { DefaultTheme } from 'styled-components';

const cruzeiroTheme = {
  colors : {
    accent : {
      primary : '#0033A0', // Azul Cruzeiro
      secondary : '#0053F7', // Azul mais claro
      tertiary : '#99CCFF', // Azul claro
    },
    surface : {
      low : '#F4F6F8',
      base : '#F9FAFB',
      high : '#FFFFFF',
    },
    text : {
      primary : '#212B36',
      secondary : '#454F5B',
      inverted : '#FFFFFF',
    },
    button : {
      text : {
        primary : '#FFFFFF',
        secondary : '#0033A0',
        disabled : '#919EAB',
      },
      surface : {
        primary : '#0033A0',
        secondary : '#FFFFFF',
        disabled : '#DFE3E8',
      },
      hover : {
        primary : '#0053F7',
        secondary : '#E3F2FD',
      },
    },
    pillbutton : {
      text : '#212B36',
      surface : '#FFFFFF',
    },
    tag : {
      socio : '#50B83C',
      coupon : '#009CD6',
      codigo : '#9C6ADE',
      face : '#50248F',
      biometria : '#99CCFF',
      promotional : '#009CD6',
      oGlobo : '#005299',
    },
    border : '#DFE3E8',
    error : '#FF6161',
    success : '#108043',
    warning : '#EEC200',
    info : '#2280EF',
    barColor : '#0033A0',
  },
  logo : {
    path : 'https://ingresse-static.s3.amazonaws.com/embedstore/logo-cruzeiro.svg',
  },
  media : {
    mobile : '@media (max-width: 767px)',
  },
  font : {
    family : 'Roboto, sans-serif',
    sizes : {
      small : '0.8rem',
      medium : '1rem',
      large : '1.2rem',
    },
  },
} as DefaultTheme;

export default cruzeiroTheme;
